import type { EntityDetailMetadata } from '@zag/ui';

export const LOCATION_DETAIL_METADATA = [
  {
    entity: 'location',
    route: '/locations/:id',
    titleKey: 'navigation.locations',
    sections: [
      { id: 'details', titleKey: 'locations.sections.details' },
      { id: 'address', titleKey: 'locations.sections.address' },
      {
        id: 'calendar-assignment',
        titleKey: 'settings.locations.calendar.title',
        visibleWhen: { mode: 'all', permissions: ['calendars:read'] },
        requiresEntityId: true,
      },
      {
        id: 'custom-properties',
        titleKey: 'common.customProperties.sectionTitle',
        visibleWhen: { mode: 'all', permissions: ['locations:read'] },
        requiresEntityId: true,
      },
    ],
    actions: [
      { id: 'save', labelKey: 'common.save', visibleWhen: { mode: 'all', permissions: ['locations:update'] }, intent: 'mutation' },
      {
        id: 'delete',
        labelKey: 'common.delete',
        visibleWhen: { mode: 'all', permissions: ['locations:delete'] },
        requiresEntityId: true,
        intent: 'mutation',
      },
    ],
  },
] satisfies readonly EntityDetailMetadata[];
